var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTomNook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "1200px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B1F09;}\n\t.st1{fill:#ECF4E9;}\n\t.st2{fill:#60625D;}\n\t.st3{fill:#458761;}\n\t.st4{fill:#9E2323;}\n\t.st5{fill:#AB7440;}\n\t.st6{fill:#7E4B1D;}\n\t.st7{fill:#D68184;}\n\t.st8{fill:#D69655;}\n\t.st9{fill:#FAFCF9;}\n\t.st10{fill:#4966B1;}\n\t.st11{fill:#D8975B;}\n\t.st12{fill:#326842;}\n\t.st13{fill:#E5CA5A;}\n\t.st14{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 838,
    cy: 344.4,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M632.4,323.9c-14.4-22.8,114-19.4,201.7-0.9c-2.1,10.6-5.8,26.5-6.4,40.1C762.2,364,647.3,347.4,632.4,323.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 416.1,
    cy: 344.4,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.8,320.9c14.5-22.8-114.6-16.5-202.4,2c2.1,10.6,5.8,26.5,6.4,40.1C491.4,364,606.9,344.5,621.8,320.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M694.9,563.1c2.3,8.7-3.5,13.5-7.9,15c-7.5,2.6-14.9,0.7-17.2-8s1.8-13.8,9.4-15.9 C686.9,552.2,692.6,554.4,694.9,563.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.6,563.1c-2.3,8.7,3.5,13.5,7.9,15c7.5,2.6,14.9,0.7,17.2-8s-1.8-13.8-9.4-15.9 C566.6,552.2,560.9,554.4,558.6,563.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M681.7,502.9c13.1-11.7,21.1-27.7,21.1-45.2c0-6.2,3.1-17.1-2.8-17.8c-27-3.1-40.6-5.3-75.4-5.3 c-35.4,0-30.1,1.3-71.5,6.6c-5.5,0.7-2.4,10.8-2.4,16.5c0,17.6,8.1,33.5,21.2,45.3c-2.4,5.3-4.5,11.4-6.1,18.1 c-3.2,13-3.9,25.2-2.4,33.6c1.1,6.3,4.6,7.1,8.1,8c3.1,0.8,7.4-0.2,10.9-4.2c5.7-6.5,9.4-16,12.9-30.1c0.9-3.5,1.5-7,2.1-10.3 c9,3.3,19,5.1,29.4,5.1c10.5,0,20.5-1.8,29.5-5.1c0.5,3.3,1.2,6.8,2.1,10.4c3.5,14.1,7.2,23.6,12.9,30.1c3.5,4,7.8,5,10.9,4.2 c3.5-0.9,7-1.7,8.1-8c1.5-8.4,0.8-20.5-2.4-33.6C686.2,514.4,684.1,508.2,681.7,502.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.3,312.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M599,316.1c6.7-3.2,15.1-5.5,23.4-5.9c2.6-0.1,5.2-0.1,7.7,0c9.7,0.5,18.6,2.7,24.2,6.3 C642.8,337.1,613.3,336.8,599,316.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M622.9,310.2c0,0-24.2,114.6-22.9,158.8c6.9,4.2,45.1,3.8,52.7,0.3c6.7-43.2-20-153.1-23.4-159.1L622.9,310.2 L622.9,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.2,176.3c3.3,10.4,14.9,10.5,27.8,6.4s22.2-10.9,18.9-21.3c-3.3-10.4-16.5-15.5-29.4-11.4 S538.8,165.9,542.2,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M545.1,165.1c1.7,5.3,9.9,4.6,19.3,1.6c9.4-3,16.5-7.2,14.8-12.4c-1.7-5.3-10.7-7.1-20.1-4.1 C549.7,153.1,543.4,159.8,545.1,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M549.4,173.7c2.2,7,9.8,6.5,18.5,3.7s15.2-6.7,13-13.7s-11.1-10.5-19.8-7.7 C552.3,158.7,547.1,166.6,549.4,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M704.4,176.3c-3.3,10.4-14.9,10.5-27.8,6.4s-22.2-10.9-18.9-21.3c3.3-10.4,16.5-15.5,29.4-11.4 C700,154.1,707.7,165.9,704.4,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M719.1,257.9c0,39.5-42.6,54.2-95.2,54.2s-95.2-14.7-95.2-54.2s15.8-88.9,95.2-88.9 C705,169.1,719.1,218.4,719.1,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M622.8,254.3c-46.3,29.2-26.3,45.1,0.8,45.1C651.3,299.4,672.4,279.9,622.8,254.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M623.1,254.9c-35.4,22.3-20.2,39.1,0.5,39.1C644.8,294,661,274.5,623.1,254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.3,256.2c-24.9,15.7-14.2,32,0.4,32C638.6,288.1,650,270,623.3,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M708.9,246c0,19.3-6.6,28.1-25,28.1c-31,0-28.1-29.4-59.9-29.4c-31.7,0-28.9,29.4-59.9,29.4 c-17.2,0-25-8.8-25-28.1c0-33.2,22.3-67.8,84.4-67.8S708.9,207.3,708.9,246z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 679.1,
    cy: 233.5,
    rx: 17.8,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 679.1,
    cy: 233.5,
    rx: 11.4,
    ry: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.4,219.6c3.3-4.8,8.2-7.9,13.7-7.9c9.8,0,17.8,9.7,17.8,21.7c0,2.5-0.3,4.9-1,7.1L665.4,219.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0_1_",
    cx: 654.3,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1_1_",
    cx: 649.1,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5_1_",
    cx: 649.1,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2_1_",
    cx: 642.8,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3_1_",
    cx: 637.6,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4_1_",
    cx: 642.8,
    cy: 216.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 571.7,
    cy: 233.5,
    rx: 17.8,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 571.7,
    cy: 233.5,
    rx: 11.4,
    ry: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M585.4,219.6c-3.3-4.8-8.2-7.9-13.7-7.9c-9.8,0-17.8,9.7-17.8,21.7c0,2.5,0.3,4.9,1,7.1L585.4,219.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0_1_",
    cx: 594.7,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1_1_",
    cx: 599.9,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5_1_",
    cx: 599.9,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2_1_",
    cx: 606.2,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3_1_",
    cx: 611.4,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4_1_",
    cx: 606.2,
    cy: 216.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M701.5,165.1c-1.7,5.3-9.9,4.6-19.3,1.6c-9.4-3-16.5-7.2-14.8-12.4c1.7-5.3,10.7-7.1,20.1-4.1 C696.9,153.1,703.1,159.8,701.5,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M697.2,173.7c-2.2,7-9.8,6.5-18.5,3.7s-15.2-6.7-13-13.7s11.1-10.5,19.8-7.7 C694.2,158.7,699.5,166.6,697.2,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M664.4,320.7c-3.1-1.6-6.3-3-9.6-4.1c-0.1,0-0.3-0.1-0.4-0.1c0,0,0,0.1-0.1,0.1c-11.5,20.6-41,20.2-55.3-0.5 c-2.8,1-5.4,2.1-7.9,3.4c-47.1,23.9-49,100.6-46.2,139.2c39.4,19.8,123.3,16,161.1,2.5C711.6,403.4,706.7,343,664.4,320.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M591.4,319.3c7.7,33.2,63,35.1,73,1.4l-10.1-4.1c-12.6,19-41.5,19.1-55.3-0.5L591.4,319.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M594.4,318.3c12.6,29.5,51.8,30.4,66,0.4l-3.1-1.1c-13.1,25.1-47.5,23.6-60.8-0.7L594.4,318.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "skeleton_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "rightShoulder",
    cx: 572.3,
    cy: 366.3,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightElbow",
    cx: 489.5,
    cy: 343.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightWrist",
    cx: 393.8,
    cy: 345.5,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightHip",
    cx: 581.1,
    cy: 564.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightKnee",
    cx: 575.6,
    cy: 725.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightAnkle",
    cx: 575.6,
    cy: 933.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftShoulder",
    cx: 681.3,
    cy: 366.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftElbow",
    cx: 765.3,
    cy: 342.3,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftWrist",
    cx: 860.6,
    cy: 344.5,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftHip",
    cx: 673.1,
    cy: 563.3,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftKnee",
    cx: 685.6,
    cy: 725.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftAnkle",
    cx: 685.6,
    cy: 933.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "572.2,366.6 581,564.4 673,563.6 681.2,366.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "571.2,366.6 489.2,343.6 393.6,345.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "682.7,366.3 765.5,342.5 860.7,344.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "581,564.4 575.5,725.5 575.5,933.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "673,563.6 685.5,725.5 685.5,933.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0",
    cx: 594.7,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1",
    cx: 592.5,
    cy: 203.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4",
    cx: 615.8,
    cy: 206.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose1",
    cx: 623.7,
    cy: 216.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3",
    cx: 606,
    cy: 202.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1",
    cx: 599.9,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0",
    cx: 588.5,
    cy: 206.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2",
    cx: 598.7,
    cy: 202.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5",
    cx: 599.9,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2",
    cx: 606.2,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3",
    cx: 611.4,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose0",
    cx: 623.7,
    cy: 210.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose3",
    cx: 623.7,
    cy: 228.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0",
    cx: 613,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightMouthCorner",
    cx: 607,
    cy: 255.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1",
    cx: 618.2,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop0",
    cx: 613.9,
    cy: 251.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose2",
    cx: 623.7,
    cy: 221.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose4",
    cx: 623.7,
    cy: 234,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipTopMid",
    cx: 624.5,
    cy: 251.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop1",
    cx: 620.4,
    cy: 250.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip",
    d: "M610.6,254.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S610.2,254.8,610.6,254.8z "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipBottomMid",
    cx: 624.5,
    cy: 264.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid",
    cx: 624.5,
    cy: 255.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid",
    cx: 624.5,
    cy: 258.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1",
    cx: 620.6,
    cy: 254.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0",
    cx: 620.6,
    cy: 257.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom1",
    cx: 620.4,
    cy: 264.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom0",
    cx: 613.4,
    cy: 261.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4",
    cx: 606.2,
    cy: 216.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "jawMid",
    cx: 624.5,
    cy: 290.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7",
    cx: 609.5,
    cy: 287.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw6",
    cx: 599.5,
    cy: 280.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw5",
    cx: 587.9,
    cy: 268.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw4",
    cx: 581.1,
    cy: 248.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw1",
    cx: 581.1,
    cy: 205.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0",
    cx: 583.6,
    cy: 196.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "topMid",
    cx: 624.7,
    cy: 170,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0",
    cx: 644.4,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1",
    cx: 657,
    cy: 182,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0",
    cx: 654.3,
    cy: 215.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1",
    cx: 656.2,
    cy: 203.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4",
    cx: 632.6,
    cy: 205.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3",
    cx: 642.6,
    cy: 202.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1",
    cx: 649.1,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0",
    cx: 660.2,
    cy: 206.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2",
    cx: 649.9,
    cy: 202.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5",
    cx: 649.1,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2",
    cx: 642.8,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3",
    cx: 637.6,
    cy: 215.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0",
    cx: 634.1,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftMouthCorner",
    cx: 642,
    cy: 255.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1",
    cx: 629.3,
    cy: 233.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop0",
    cx: 635.1,
    cy: 251.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop1",
    cx: 628.7,
    cy: 250.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip",
    d: "M638.4,254.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S638,254.8,638.4,254.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1",
    cx: 628.5,
    cy: 254.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0",
    cx: 628.5,
    cy: 257.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom1",
    cx: 628.7,
    cy: 264.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom0",
    cx: 635.6,
    cy: 261.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4",
    cx: 642.8,
    cy: 216.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7",
    cx: 639.3,
    cy: 287.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw6",
    cx: 649.3,
    cy: 281.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw5",
    cx: 660.9,
    cy: 268.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw4",
    cx: 667.7,
    cy: 248.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3",
    cx: 668.5,
    cy: 227,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw1",
    cx: 667.7,
    cy: 205.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0",
    cx: 665.2,
    cy: 196.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "624.5,170 604.7,172.5 592.2,182 583.6,196.1 581.1,205.4 580.3,217.1 580.3,226.6 581.1,248.3  587.9,268.3 599.5,280.8 609.5,287.5 624.5,290.7 639.3,287.9 649.3,281.2 660.9,268.6 667.7,248.6 668.5,227 668.5,217.4  667.7,205.7 665.2,196.5 657,182 644.4,172.5 624.5,170  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "588.5,206.9 592.5,203.2 598.7,202.2 606,202.2 615.8,206.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "594.7,215.1 599.9,211.4 606.2,211.4 611.4,215.6 606.2,216.6 599.9,217.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "613,233.2 618.2,233.2 623.7,234 623.7,228.7 623.7,221.6 623.7,216.1 623.7,210.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "660,206.5 656,203.6 649.7,202.1 642.4,202.5 632.4,205.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "654.1,215.1 648.8,211.4 642.5,211.4 637.4,215.6 642.5,216.6 648.8,217.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "634.1,233.2 629.1,233.2 623.7,234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "607,255.3 613.9,251.9 620.4,250.8 624.5,251.7 628.7,250.8 635.1,251.9 642,255.3 635.6,261.6  628.5,264.4 624.5,264.9 620.4,264.4 613.4,261.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "607,255.3 610.6,255.6 620.6,254.8 624.5,255.3 628.5,254.8 638.4,255.6 642,255.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "607,255.3 610.6,255.6 620.6,257.7 624.5,258.5 628.5,257.7 638.4,255.6 642,255.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0",
    cx: 604.8,
    cy: 172.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1",
    cx: 592.2,
    cy: 182,
    r: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomNook);
export default __webpack_public_path__ + "static/media/tom-nook.165940d38f6a77fdc4391ea949fd43e7.svg";
export { ForwardRef as ReactComponent };